// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_TRANSATION_LIST = "GET_TRANSATION_LIST";
export const GET_ORDRER_LIST = "GET_ORDRER_LIST";
